// Opens a print-friendly window for a signed consent record and triggers the browser print dialog.
import { escapeDeep } from './escapeHtml';
export function printConsentRecord(rawRecord) {
  const record = escapeDeep(rawRecord);
  const items = (record.items_received && record.items_received.length)
    ? `<div style="margin:12px 0"><strong>Items received:</strong><ul>${record.items_received.map((i) => `<li>${i}</li>`).join('')}</ul></div>`
    : '';
  const signedAt = record.resident_signed_at ? new Date(record.resident_signed_at).toLocaleString() : '';
  const html = `<!doctype html><html><head><title>${record.document_title}</title>
    <style>
      body{font-family:Georgia,serif;max-width:720px;margin:40px auto;color:#111;line-height:1.6;padding:0 20px}
      h1{font-size:20px;border-bottom:2px solid #333;padding-bottom:8px}
      .meta{color:#555;font-size:13px;margin-bottom:16px}
      .body{font-size:15px;margin:18px 0;white-space:pre-wrap}
      .sig{margin-top:32px;border-top:1px solid #ccc;padding-top:16px}
      .row{display:flex;justify-content:space-between;margin:10px 0}
      .line{border-bottom:1px solid #333;min-width:220px;padding-bottom:2px}
      .label{font-size:12px;color:#666}
    </style></head><body>
    <h1>${record.document_title}</h1>
    <div class="meta">Resident: <strong>${record.resident_name}</strong> &nbsp;|&nbsp; Date signed: ${signedAt}</div>
    <div class="body">${(record.document_body || '')}</div>
    ${items}
    <div class="sig">
      <div class="row"><div><div class="line">${record.resident_signature || ''}</div><div class="label">Resident signature</div></div>
      <div><div class="line">${signedAt}</div><div class="label">Date</div></div></div>
      ${record.staff_signature ? `<div class="row"><div><div class="line">${record.staff_signature}</div><div class="label">Staff signature</div></div></div>` : ''}
      ${record.witness_signature ? `<div class="row"><div><div class="line">${record.witness_signature}</div><div class="label">Witness signature</div></div></div>` : ''}
    </div>
    <script>window.onload=function(){window.print();}</script>
    </body></html>`;
  const w = window.open('', '_blank', 'width=800,height=900');
  if (w) { w.document.write(html); w.document.close(); }
}
